/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

let version = document.head.querySelector('meta[name="version"]')
    ? document.head.querySelector('meta[name="version"]').content
    : 'n/a';

window.Vue = require('vue');

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
window.Sentry = Sentry;
window.Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
    integrations: [
        new Integrations.Vue({
            attachProps: true,
        }),
    ],
    release: 'birch@' + version,
    environment: process.env.MIX_APP_ENV,
});

import Vuex from 'vuex';
const store = new Vuex.Store({});

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import Tooltip from 'v-tooltip';
Vue.use(Tooltip);

import Lego from '@lego/js/store-front/store-front';
Vue.use(Lego, store);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example', require('./components/Example').default);

Vue.component(/* webpackPrefetch: true */ 'accordion', () =>
    import('./components/Accordion' /* webpackChunkName: "js/accordion" */)
);

Vue.component('klarna-pay-as-low-as', () =>
    import('./components/Klarna/PayAsLowAs' /* webpackChunkName: "js/klarna-pay-as-low-as" */)
);

Vue.component(/* webpackPrefetch: true */ 'nav-cart', () =>
    import('./components/NavCart' /* webpackChunkName: "js/nav-cart" */)
);

Vue.component(/* webpackPrefetch: true */ 'footer-email-capture', () =>
    import('./components/FooterEmailCapture' /* webpackChunkName: "js/footer-email-capture" */)
);

Vue.component(/* webpackPrefetch: true */ 'save-for-later-email-capture', () =>
    import(
        './components/SaveForLaterEmailCapture' /* webpackChunkName: "js/save-for-later-email-capture" */
    )
);

Vue.component(/* webpackPrefetch: true */ 'old-mattress-removal-zip-code-checker', () =>
    import(
        './components/OldMattressRemovalZipCodeChecker' /* webpackChunkName: "js/old-mattress-removal-zip-code-checker" */
    )
);

Vue.component('warranty-module', () =>
    import('./components/Warranty' /* webpackChunkName: "js/warranty-module" */)
);

Vue.component('modal-fullscreen', () =>
    import('./modals/ModalFullscreen' /* webpackChunkName: "js/modal-fullscreen" */)
);

Vue.config.ignoredElements = ['klarna-placement'];

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Heap from '@lego/js/services/Heap';
import Zibby from '@lego/js/services/Zibby';
import Zaius from '@lego/js/services/Zaius';
import Klarna from '@lego/js/services/Klarna';
import Kustomer from '@lego/js/services/Kustomer';
import DataLayer from '@lego/js/services/DataLayer';

import Events from './events';

window.vue = new Vue({
    el: '#app',
    store,

    mixins: [Events],

    data: {
        mobileNavIsShowing: false,
        activeSubmenu: '',
        services: {
            dataLayer: DataLayer,
            chat: Kustomer,
            heap: Heap,
            klarna: Klarna,
            zaius: Zaius,
            zibby: Zibby,
        },
    },

    directives: {
        minHeight: {
            inserted: function(el, bindings, vnode) {
                el.style.minHeight =
                    Math.ceil(
                        (vnode.elm.clientWidth / bindings.expression) * vnode.elm.clientWidth
                    ) + 'px';
            },
        },
    },

    mounted() {
        if (typeof this.$refs.promobar !== 'undefined') {
            this.handleNavScrollWithPromobar();
        } else {
            this.handleNavScrollWithoutPromobar();
        }
    },

    methods: {
        toggleMobileNav() {
            this.activeSubmenu = '';
            this.mobileNavIsShowing = !this.mobileNavIsShowing;

            if (this.mobileNavIsShowing) {
                document.body.style.setProperty('overflow', 'hidden');
            } else {
                document.body.style.removeProperty('overflow');
            }
        },

        toggleSubmenu(name) {
            this.activeSubmenu = this.activeSubmenu !== name ? name : '';
        },

        handleNavScrollWithPromobar() {
            let nav = this.$refs.nav;
            let navWrapper = this.$refs.navWrapper;

            if (!nav || !navWrapper) {
                return;
            }

            navWrapper.style.marginBottom = '-' + navWrapper.offsetHeight + 'px';

            let observer = new IntersectionObserver(entries => {
                let promobar = entries[0];

                if (promobar.isIntersecting) {
                    navWrapper.classList.add('relative');
                    navWrapper.classList.remove('fixed', 'pin', 'h-px');
                    nav.classList.add('bg-transparent');
                    nav.classList.remove('bg-white');
                } else {
                    navWrapper.classList.add('fixed', 'pin', 'h-px');
                    navWrapper.classList.remove('relative');
                    nav.classList.add('bg-white');
                    nav.classList.remove('bg-transparent');
                }
            });

            observer.observe(this.$refs.promobar);
        },

        handleNavScrollWithoutPromobar() {
            let nav = this.$refs.nav;
            let navWrapper = this.$refs.navWrapper;

            if (!nav || !navWrapper) {
                return;
            }

            // The "h-px" is for the nav not to take over the
            // whole screen and make clicks impossible.
            navWrapper.classList.add('fixed', 'pin', 'h-px');

            let observer = new IntersectionObserver(entries => {
                let topOfPageEntry = entries[0];

                // Is at the top of the page
                if (topOfPageEntry.isIntersecting) {
                    nav.classList.add('bg-transparent');
                    nav.classList.remove('bg-white');

                    // No longer at the top of the page
                } else {
                    nav.classList.add('bg-white');
                    nav.classList.remove('bg-transparent');
                }
            });

            observer.observe(this.$refs.topOfPage);
        },
    },
});
